import React from 'react'
import { ReactPDF, View, Page, Text, Image, Document, StyleSheet, Font } from "@react-pdf/renderer";
import { timePassed } from '../../lib/utils';
import {BackButton} from '../frontend_components/BackButton';
import { useStateContext } from '../../context/StateContext';


const border = {color: "#ece2e2", size: 1 } 
Font.register({
    family: 'Open Sans',
    fonts: [
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: "bold" }
    ]
    });


const styles = StyleSheet.create({
    body: {
      paddingTop: 20,
      paddingBottom: 20,
      paddingHorizontal: 20,
    },
    title: {
      fontSize: 14,
      textAlign: 'center',
      //fontFamily: 'Oswald'
    },
    author: {
      fontSize: 12,
      textAlign: 'center',
      marginBottom: 40,
    },
    subtitle: {
      fontSize: 10,
      margin: 5,
      //fontFamily: 'Oswald'
    },
    text: {
      margin: 12,
      fontSize: 10,
      textAlign: 'justify',
      fontFamily: 'Times-Roman'
    },
    image: {
      marginVertical: 15,
      marginHorizontal: 100,
    },

    header: {
      fontSize: 7,
      //textAlign: 'center',
      color: 'black',
      width:"100%",
      border: border.size,
      borderColor: border.color,
    },
        logoContainer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: border.size,
            borderBottomColor: border.color,
            padding: 5,
        },

            logo: {
                width: 200, 
                height: 26.6
            },

            signature: {
                width: 81, 
                height: 40
            },
        siteInfo: {
            display:"flex",
            flexDirection:"row",
            borderBottom: border.size,
            borderBottomColor: border.color,
            alignItems: "center",
            justifyContent:"center",
            padding:5
            
        },
        siteInfoSide:{
            display:"flex",
            flex:1,
            alignItems: "left",
            justifyContent:"left",
            textAlign: "left"
        },
        siteInfoCenter:{
            display:"flex",
            flex:1,
            alignItems: "center",
            justifyContent:"center",
            textAlign: "center"
            
        },
        siteInfoRight:{
            display:"flex",
            flex:1,
            alignItems: "flex-end",
            justifyContent:"right",
            textAlign: "right"
        },
                registerHeaderField : {
                display: "flex",
                flexDirection:"row",
                width:"100%",
                //fontSize: 10,
                flexWrap:"wrap",
                //alignItems: "center",
                
                //fontWeight: "extrabold",
                },

                    registerHeaderFieldTitle:{
                        fontFamily: 'Open Sans',
                        fontWeight: "light", 
                        textDecoration:"underline",
                        //widht: 120,   
                        marginRight:5,  
       
                        //backgroundColor:"grey"
                    },
                    registerHeaderFieldData: {
                        fontFamily: 'Open Sans',
                        fontWeight: "bold", 
                        //width:"100%",
                        //backgroundColor:"blue",
                        marginRight:5,  
                        //backgroundColor:"red"
                    },

    tableHeader:{ 
        display:"flex",
        flexDirection:"row",
        alignItems:"center",
        justifyContent:"center",
        backgroundColor:"#d8d8d8",
        minHeight: 20
        
    },
    tableColumn:{ 
        display:"flex",
        textAlign:"center",
        fontSize: 6,
        alignItems:"center",
        justifyContent:"center",
        //left: "50%",
        //right:"50%",
        //paddingHorizontal:"2px",
        paddingVertical:"4px",
        overflow:"hidden",
        width:"100%",
        textOverflow:"ellipsis",
    },

    table:{ 
        display:"flex",
    },

    tableRow:{ 
        display:"flex",
        flexDirection:"row",
        alignItems:"center",
        justifyContent:"center",
        textOverflow:"ellipsis",
        minHeight: 20,

    },
    tableCell:{
        textAlign:"center",
        overflow:"hidden",
        fontSize: 7,
        display: "flex",
        alignItems:"center",
        justifyContent:"center",
        //height: "100%",
        //width:"100%",
        //paddingHorizontal:"6px",
        paddingVertical:"8px",
        borderRight: border.size,
        borderRightColor: border.color,
        borderRightStyle: "dotted",
      
    },
    symbol: {
        width: 10, 
        height: 10, 
    },
    footerInfo: {
        display:"flex",
        flexDirection:"row",
        alignItems: "center",
        justifyContent:"center",
        padding:5,
        //backgroundColor:"red",
   
    },

    footerInfoRight:{
        display:"flex",
        flex:1,
        alignItems: "flex-end",
        justifyContent: "flex-end",
        textAlign: "right"
    },

    pageNumber: {
      //position: 'absolute',
      fontSize: 8,
      //bottom: 30,
      left: 0,
      right: 0,
      textAlign: 'center',
      color: 'grey',
    },
  });

  /*
            <Text>{tableData.columns[0]}</Text>
            <Text>{tableData.columns[1]}</Text>
            <Text>{tableData.columns[2]}</Text>
    }
  */

//const rowColour = index % 2 ? "white":"#f3f4f3"

Font.registerHyphenationCallback(word => [word]);


const registerheaderField = (title, data, size=10) => { 
    
    return(
    <View debug={false}  style={{...styles.registerHeaderField, fontSize:size}}>
        <Text style={styles.registerHeaderFieldTitle}>{title}</Text>
        <Text style={styles.registerHeaderFieldData}>{data}</Text>
    </View>
) }

function compare( a, b ) {
    if ( a?.order < b?.order ){
      return -1;
    }
    if ( a?.order > b?.order ){
      return 1;
    }
    return 0;
  }



const indirizzo = (headerData) => (headerData.address1 + headerData.houseNumber + headerData.address2 + headerData.postcode + headerData.city) 

const PdfRegistro = ({headerData, tableData, manualDate, LDB}) => {


    const orderedColumns = !tableData?.columns ? [] : tableData?.columns
    ?.filter((x) => {return x?.accessor !== "info"})
    ?.map?.((item)=>{
        const order = () => {
          if(item.accessor == "presidio") return 5
          if(item.accessor == "esito") return 99
          if(item.accessor == "nonConformita") return 98
          if(item.accessor == "_id") return 0
    
          return item?.order
        }
      return(
      {
        ...item,
        order: order()
      }
    )})

    //console.log("orderColumns", orderedColumns)
    const clientName = () => {
        
        if(!headerData.notComune) return `COMUNE DI ${headerData.client}`
        return headerData.client
      }

    const columnFlex = (item) => {
        if(item.accessor=="nonConformita") return 4.5
        if(item.accessor=="2e587bd1-e26e-4938-9c26-d7c16199ffe6") return 2.8
        if(item.accessor=="presidio") return 2
        return 1  
    }
    const columnMaxWidth = (item) => {
        //if(item.accessor == "esito") return ({maxWidth: 25 })
        if(item?.maxWidth) return ({maxWidth: item?.maxWidth })
        return {}  
    }
    const columnMinWidth = (item) => {
        if(item.accessor == "esito") return ({minWidth: 16 })
        if(item?.minWidth) return ({minWidth: item?.minWidth })
        if(item.accessor == "presidio") return ({minWidth: 30})
        //SCADENZE COLLAUDI
        if(item.accessor == "ddl-0fd77d32-922b-465c-ac9c-6fac4f3f12b5") return ({minWidth: 20})
        if(item.accessor == "ddl-df6c2f10-548b-43d5-a8eb-86c4aef56cbf") return ({minWidth: 20})
        if(item.accessor == "ddl-8da7d159-0b11-4477-882c-5e8774f8bbe8") return ({minWidth: 20})
        //SCADENZE COLLAUDO REVISIONE
        if(item.accessor == "ddl-3dcc8283-acda-4cf0-8d1d-240ea0086821") return ({minWidth: 20})
        if(item.accessor == "ddl-5509152e-2956-43b3-9c4d-4a327034e191") return ({minWidth: 20})
        //SCADENZE TAGLIANDO
        if(item.accessor == "ddl-b049d4bb-67a6-49de-bfb9-5c5df0aedc32") return ({minWidth: 20})
        if(item.accessor == "ddl-1ea2682f-6eb5-4cbe-918f-04e8c0255930") return ({minWidth: 20})
        if(item.accessor == "ddl-d98b32fd-b8b5-49d9-9210-199d0f314d97") return ({minWidth: 20})
    
        return {}  
    }
    const columnSize = (item) => ({...columnMaxWidth(item), ...columnMinWidth(item), flex: columnFlex(item)})
    const clientLabel = headerData?.clientLabel
    const addressLabel = headerData?.addressLabel

    return (
    <Document> 
      <Page style={styles.body} orientation='landscape'>
        <View style={styles.header} fixed>
            <View style={styles.siteInfo}>
                <View style={styles.siteInfoSide}>  
                </View>
                <View style={styles.siteInfoCenter}>
                    <Image
                        style={{
                            width: (headerData?.customerLogoWidth), 
                            height: (headerData?.customerLogoHeight),
                            //transform: scale(0.3, 0.3),
                        }}
                        layout="fill"
                        src={headerData.customerLogo}
                    />   
                </View>
                <View style={styles.siteInfoRight}>
                </View>
            </View>
            <View style={styles.siteInfo}>
                <View style={styles.siteInfoSide}>
                    {registerheaderField (`${clientLabel}:`,clientName())}
                </View>
                <View style={styles.siteInfoCenter}>
                    <View>
                        {registerheaderField ("",headerData?.site, 12)}
                    </View>
                </View>
                <View style={styles.siteInfoRight}>
                    <View>
                        {indirizzo(headerData) && registerheaderField (`${addressLabel}:`,indirizzo(headerData))}
                    </View>
                </View>
            </View>
            <View style={styles.siteInfo}>
                <View style={styles.siteInfoSide}>
                {headerData?.registerNonConformities?.length >0 ? headerData.templateRegisterFields && <Text style={{color:"red", fontSize:7, padding: 5}}>{headerData.templateRegisterFields[0].label}</Text> : undefined}
                </View>
                <View style={{...styles.siteInfoCenter,flexDirection:"column", textAlign: "center"}}>
                    <Text style={styles.title}>{"REGISTRO "+ headerData?.register}</Text>
                    <Text>{headerData?.registerName ? headerData?.registerName : ""}</Text>
                    <Text>{headerData?.description}</Text>
                </View>
                <View style={[styles.siteInfoRight, {flexDirection:"column"}]}>
                    <View>
                        {!manualDate && headerData?.lastCheck && registerheaderField ("ULTIMO CONTROLLO:", timePassed(headerData?.lastCheck, true))}
                        {manualDate && registerheaderField ("ULTIMO CONTROLLO:", manualDate )}
                    </View>
                    <View style={{marginTop:3}}>
                        {headerData?.technician && registerheaderField ("TECNICO:", headerData?.technician?.firstName + " " + headerData?.technician?.lastName)}
                    </View>
                </View>
            </View>
            <Text style={{color:"red", fontSize:8, padding: 5}}>{headerData.notes}</Text>

            <View wrap={false} style={styles.tableHeader}>
                {orderedColumns.sort(compare).map?.((item, index)=>{
                const columnLabel = () => {

                    const header = () => {
                        const label = `${item?.Header}`
                        //if(label == "SCADENZA ESERCIZIO") return LDB("fields","assetExpiry")
                        //if(label == "ANNO DI PRODUZIONE") return LDB("fields","productionYear")
                        //if(label == "ESITO NEGATIVO") return LDB("fields","negativeOutcome")
                        //if(label == "NON CONFORMITA'") return LDB("device","nonConformities")
                       
                        return label}


                if(item?.symbolLink) {
                    return (
                        <View key={index} style={{...styles.tableColumn, ...columnSize(item)}}> 
                            <Text>{header()}</Text>
                            <Image
                                style={styles.symbol}
                                src={item?.symbolLink}
                            />     
                        </View>
                    )
                }
                
                return <Text key={index} style={{...styles.tableColumn, ...columnSize(item)}}>{header()}</Text>
                }
                    if(tableData?.hideColumns?.some?.((y)=>item?.accessor==y)) return undefined
                    return(
                        columnLabel()
                )})}
            </View>
        </View>

        <View style={styles.table}>
        {tableData?.data && tableData?.data.map?.((row, index)=>{
            const rowColour = index % 2 ? "white":"#f3f4f3"
            return (
                <View wrap={false} key={index} style={[ styles.tableRow, {backgroundColor: rowColour}]}>
                    {orderedColumns.sort(compare).map?.((item, index)=>{
                        
                       const symbol = item?.symbolLink
                       const trueValue = item.trueValue
                       
                        const value = () => {
                          const value = row[item.accessor]
                          const accessorFirst4Characters = item.accessor?.slice(0,4)
                          //const isValueADate = value?.getTime() ? true : false
                          //console.log("PDF VALUE", accessorFirst4Characters)
                          if(accessorFirst4Characters == "ddl-"){
                            const now = new Date().getFullYear()
                            if(!value) return <Text wrap={false} key={index} style={{...styles.tableCell, ...columnSize(item)}}>{""}</Text>
                            if(value < now) return <Text wrap={false} key={index} style={{...styles.tableCell, ...columnSize(item)}}>{now?.toString()}</Text>
                            return <Text wrap={false} key={index} style={{...styles.tableCell, ...columnSize(item)}}>{value}</Text>
                          }
                          if(symbol && !value) return <View wrap={false} key={index} style={{...styles.tableCell, ...columnSize(item)}}><Image style={{...styles.symbol}} src={item?.symbolLink}/></View> 
                          if(trueValue, !value) return <Text wrap={false} key={index} style={{...styles.tableCell, ...columnSize(item)}}>{trueValue}</Text>
                          if(!trueValue, !value) return <Text wrap={false} key={index} style={{...styles.tableCell, ...columnSize(item)}}>{""}</Text>
                          if(!value) return <Text wrap={false} key={index} style={{...styles.tableCell, ...columnSize(item)}}>{""}</Text>
                            return <Text wrap={false} key={index} style={{...styles.tableCell, ...columnSize(item)}}>{value}</Text>

                        }

                    if(tableData?.hideColumns.some?.((y)=>item.accessor==y)) return undefined
                    
                        return value()  
                                    
                    })}
                </View>
            )
        })}

        </View>
        <View fixed style={styles.footerInfo}>
                <View style={styles.siteInfoSide}>  
                </View>
                <View style={styles.siteInfoCenter}>
                    <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
                        `${pageNumber} / ${totalPages}`
                    )} />   
                </View>
                <View style={styles.footerInfoRight}>
                 {   
                headerData.customerSignature && <Image
                        style={styles.signature}
                        src={headerData.customerSignature}
                    /> } 
                </View>
            </View>

      </Page>
    </Document>
  );
}
  

  

export default PdfRegistro



